import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { OmaLummeApp } from '../../omaLummeContext';

import Loading from '../Common/Loading';
import Box from '../Common/Box';
import CustomerDetails from './CustomerDetails';
// Utils.
import { gaPageviewIfAllowed } from '../../utils/googleAnalytics';

const OomiLockDownDate = new Date('2026-05-01T00:00:00Z');
const OomiLockDownDateProd = new Date('2026-09-01T00:00:00Z');
const currentDate = new Date();
export const hideUpdateInfo = currentDate >= OomiLockDownDateProd;

export const MyInfo: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { users } = OmaLummeApp.useState();
  const [pageview, setPageview] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!pageview) {
      gaPageviewIfAllowed('/myinfo');
      setPageview(true);
    }
  }, [pageview]);

  const usersLoading = users.activeUser.userId === 0 && users.activeUser.userName === '';

  return (
    <Box>
      <h1 aria-live="polite">{t('myInfo:customerInfo.customerInfoTitle')}</h1>
      {!hideUpdateInfo ? (
        <p>{t('myInfo:customerInfo.ingress')}</p>
      ) : (
        <p>
          <Trans i18nKey="myInfo:customerInfo.ingressOomi">
            . <a href="https://www.lumme-energia.fi/oomi" target="_blank" rel="noopener noreferrer">https://www.lumme-energia.fi/oomi</a>
          </Trans>
        </p>
      )}
      {usersLoading && <Loading />}
      {!usersLoading && (
        <>
          {/* {noAddresses && <p>{t(`myInfo:customerInfo.noAddresses`)}</p>} */}
          <CustomerDetails customer={users.parentUser} type="parent" />
          {users.childUsers && users.childUsers.length > 0 && (
            <>
              <h2 className="h4">{t('myInfo:customerInfo.representedCustomersTitle')}</h2>
              {users.childUsers.map((child) => (
                <CustomerDetails key={child.userId} customer={child} type="child" />
              ))}
            </>
          )}
        </>
      )}
    </Box>
  );
};

export default MyInfo;
